import React from 'react';

interface HomeProps {
  onExperienceClick: (section: string) => void;
}

export function Home({ onExperienceClick }: HomeProps) {
  return (
    <div className="space-y-4">
      <div className="bg-primary rounded-lg shadow-md aspect-square relative overflow-hidden">
        <div className="absolute inset-x-0 top-1/3 -translate-y-1/2 px-6">
          <img 
            decoding="async"
            loading="lazy"
            width="100%"
            height="auto"
            src="https://assets.brandbay.io/brands/1740757220342x324895480323506200/assets/UB0gOwLogo_Sandra_sq_rosa_1000x500.jpg"
            alt="Logo Sandra"
            className="w-full max-w-[280px] mx-auto"
          />
        </div>
        <p className="text-center text-white text-lg absolute bottom-6 left-0 right-0 px-6">
          Estética y Quiromasaje<br />
          para mujeres en Paterna
        </p>
      </div>

      <button 
        onClick={() => onExperienceClick('experience')}
        className="w-full bg-white rounded-lg shadow-md p-4 pulse-effect gradient-animate hover:bg-gray-50 transition-colors"
      >
        <h2 className="text-lg font-semibold text-primary text-center mb-2">EXPERIENCIA DEL MES</h2>
        <div className="text-center text-lg text-gray-600 mb-4">
          Descubre el tratamiento especial
        </div>
        <div className="text-center">
          <span className="inline-block bg-primary text-white px-4 py-1.5 rounded-full text-sm">
            DESCUBRIR
          </span>
        </div>
      </button>

      <div className="text-center pt-[100px] space-y-2">
        <button 
          onClick={() => onExperienceClick('legal')} 
          className="text-gray-800 hover:text-primary transition-colors"
        >
          Aviso legal
        </button>
        <button 
          onClick={() => onExperienceClick('terms')} 
          className="block w-full text-gray-800 hover:text-primary transition-colors"
        >
          Condiciones generales de uso
        </button>
      </div>
    </div>
  );
}